import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const location = useLocation();
  
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo-link">
            <h1 className="company-name">주식회사 애드플러스디벨롭먼트</h1>
            <p className="company-subtitle">AdPlus Development Co., Ltd.</p>
          </Link>
        </div>
        <nav className="header-nav">
          <Link 
            to="/" 
            className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}
          >
            홈
          </Link>
          <Link 
            to="/about" 
            className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}
          >
            회사소개
          </Link>
          <Link 
            to="/notice" 
            className={`nav-item ${location.pathname === '/notice' ? 'active' : ''}`}
          >
            전자공고
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;